// @ts-nocheck
import { updateAccount, UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = boolean;
type HandlerType = Handler<Parameter>;

export const SetShowWelcomePopup: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Checkout/SetWelcomePopup",
        showWelcomePopup: props.parameter,
    });
};
export const UpdateAccount: HandlerType = async props => {
    if (props.parameter === false) {
        const currentAccount = getCurrentAccountState(props.getState()).value;

        if (currentAccount) {
            const apiParameter: UpdateAccountApiParameter = {
                account: {
                    ...currentAccount,
                    properties: {
                        ...currentAccount?.properties,
                        hasReadWelcomeLetter: "true",
                    },
                },
            };
            await updateAccount(apiParameter);
        }
    }
};

export const chain = [SetShowWelcomePopup, UpdateAccount];

const setShowWelcomePopup = createHandlerChainRunner(chain, "SetShowWelcomePopup");
export default setShowWelcomePopup;
